import { render } from "./App.vue?vue&type=template&id=5730ff48"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5730ff48&lang=scss"

import exportComponent from "/builds/iiot/default/anti-fake-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__